// extracted by mini-css-extract-plugin
export default {"videoPlayer":"CustomVideoPlayer_videoPlayer__29NCA","controls":"CustomVideoPlayer_controls__PGF+p"};